import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import LoginWrapper from "../loginWrapper";
import localizationStrings from "../../statics/localization";
import Notification from "../notification";
import ShowPasswordIcon from "../../assets/icons/svg/ShowPasswordIcon";
import HidePasswordIcon from "../../assets/icons/svg/HidePasswordIcon";
import mainLoadingGif from "../../assets/loading.gif";
import "./resetPassword.scss";
import { resetPassword } from "../../api/login/loginApi";

const ResetPassword = () => {
  const [isShownPassword, setIsShownPassword] = useState(false);
  const [isShownConfirmPassword, setIsShownConfirmPassword] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationText, setNotificationText] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const { token } = useParams();
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch
  } = useForm();

  const { emptyMessageText } = localizationStrings;
  const { confirm, login, changePassword, newPassword, newPasswordAgain, resetPWSuccess, resetPwError, matchPasswords,minPwLength } = localizationStrings.login;

  const password = watch("password");

  const handleResetPassword = async (data) => {
    if (data.password !== data.confirmPassword) {
      setNotificationText(matchPasswords);
      setShowNotification(true);
      return;
    }

    setShowLoading(true);
    
    try {
      await resetPassword(token, data.password);
      setNotificationText(resetPWSuccess);
      setShowNotification(true);
      
      // Redirect to login page after successful password reset
      setTimeout(() => {
        history.push("/login");
      }, 2000);
    } catch (error) {
      console.error("Reset password error:", error);
      setNotificationText(resetPwError);
      setShowNotification(true);
    }
    
    setShowLoading(false);
  };

  const handleTogglePassword = () => {
    setIsShownPassword((prevState) => !prevState);
  };

  const handleToggleConfirmPassword = () => {
    setIsShownConfirmPassword((prevState) => !prevState);
  };

  const registerOptions = {
    password: {
      required: `${emptyMessageText}`,
      minLength: {
        value: 6,
        message: minPwLength
      }
    },
    confirmPassword: {
      required: `${emptyMessageText}`,
      validate: (value) =>
        value === password || matchPasswords
    }
  };

  // Check if token exists
  useEffect(() => {
    if (!token) {
      history.push("/login");
    }
  }, [token, history]);

  return (
    <LoginWrapper>
      {showLoading ? (
        <div className="loading">
          <img src={mainLoadingGif} alt="loading" />
        </div>
      ) : (
        <>
          <p className="login-title">{changePassword}</p>
          <p className="reset-password-subtitle">Yeni şifrenizi belirleyin</p>
          
          <div className="password-section input-box">
            <input
              className="input-password"
              name="password"
              id="password"
              type={isShownPassword ? "text" : "password"}
              {...register("password", registerOptions.password)}
              style={
                errors.password
                  ? { border: "2px solid red" }
                  : {}
              }
              required
            />
            <label htmlFor="password">{newPassword}</label>

            <span className="eye-icon" onClick={handleTogglePassword}>
              {isShownPassword ? <ShowPasswordIcon /> : <HidePasswordIcon />}
            </span>

            {errors?.password ? (
              <div className="input-error">
                <p>{errors?.password && errors.password.message}</p>
              </div>
            ) : null}
          </div>

          <div className="password-section input-box">
            <input
              className="input-password"
              name="confirmPassword"
              id="confirmPassword"
              type={isShownConfirmPassword ? "text" : "password"}
              {...register("confirmPassword", registerOptions.confirmPassword)}
              style={
                errors.confirmPassword
                  ? { border: "2px solid red" }
                  : {}
              }
              required
            />
            <label htmlFor="confirmPassword">{newPasswordAgain}</label>

            <span className="eye-icon" onClick={handleToggleConfirmPassword}>
              {isShownConfirmPassword ? <ShowPasswordIcon /> : <HidePasswordIcon />}
            </span>

            {errors?.confirmPassword ? (
              <div className="input-error">
                <p>{errors?.confirmPassword && errors.confirmPassword.message}</p>
              </div>
            ) : null}
          </div>

          <button
            onClick={handleSubmit(handleResetPassword)}
            className="sign-in-button"
          >
            {changePassword}
          </button>

          {/* <div className="forgot-password">
            <Link to="/login">Giriş Sayfasına Dön</Link>
          </div> */}

          {showNotification ? (
            <Notification
              text={notificationText}
              confirmText={confirm}
              onClickConfirm={() => setShowNotification(false)}
            />
          ) : null}
        </>
      )}
    </LoginWrapper>
  );
};

export default ResetPassword;
